<script context="module">
  // @ts-check

  /**
   * Array of valid aspect ratios for the Image component.
   * @type {("portrait" | "landscape" | "square")[]}
   */
  export const VALID_ASPECT_RATIOS = ["portrait", "landscape", "square"];
</script>

<script>
  // @ts-check
  import Image from "../atoms/Image.svelte";
  import Markdown from "../atoms/Markdown.svelte";

  /** @type { string } */
  let className = "";
  export { className as class };

  /**
   * Primarily used for testing
   * @type {string}
   */
  export let id = null;

  /**
   * @type {import('../types/shared.js').Image}
   */
  export let image = null;

  /**
   * The caption for the image
   * @type {string}
   */
  export let caption = null;

  /**
   * The external class for the ImageContent element.
   * @type {string}
   */
  export let containerClasses = "";

  /**
   * The aspect ratio of the image used to generate aspect ratio classes.
   * @type {typeof VALID_ASPECT_RATIOS[number]}
   */
  export let aspectRatio = "landscape";

  /**
   * Controls whethere the caption should have padding on the left and right
   * @type { boolean }
   */
  export let isCaptionFullBleed = false;

  const captionWrapperClasses = isCaptionFullBleed ? "px-7.5 lg:px-15" : "";

  const imageAspectRatios = {
    square: "aspect-1/1",
    portrait: "aspect-3/4",
    landscape: "aspect-3/2"
  };
</script>

<figure class="w-full {containerClasses} {className}" {id}>
  <Image
    {...image}
    containerElement="div"
    aspectRatioClasses={imageAspectRatios[aspectRatio]
      ? imageAspectRatios[aspectRatio]
      : aspectRatio}
  />
  {#if caption || $$slots.caption}
    <figcaption class="body-sm mt-3 {captionWrapperClasses}">
      <slot name="caption">
        <Markdown element="span" input={caption} id="markdown-caption-${id}" />
      </slot>
    </figcaption>
  {/if}
</figure>
